import React from "react";
import "./Administrators.css";

const trustee = {
  name: "H.H. Sree Padmanabhadasa Moolam Thirunal Rama Varma",
  designation: "Trustee",
  image: "./administrators/trustee.jpeg",
};

const administrativeMembers = [
  {
    name: "Sri. Anilkumar K P",
    designation:
      "Chairman, Additional District & Sessions Judge - I, Trivandrum",
    image: "./administrators/anil.jpg",
    // featured: true,
  },
  {
    name: "Adithya Varma",
    designation: "",
    image: "./administrators/Adithya.jpeg",
  },
  {
    name: "Karamana Jayan",
    designation: "",
    image: "./administrators/jayan.jpg",
  },
  {
    name: "Adv. A. Velappan Nair",
    designation: "",
    image: "./administrators/velappan.png",
  },
  {
    name: "Govindan Namboodiripad",
    designation: "",
    image: "./administrators/govindan.png",
  },
];

const advisoryMembers = [
  {
    name: "Justice T R Ramachandran Nair (Rtd.)",
    designation: "Chairman",
    image: "./administrators/justice.jpeg",
    // featured: true,
  },
  {
    name: "T. Balakrishnan IAS (Rtd.)",
    designation: "",
    image: "./administrators/bala.jpeg",
  },
  {
    name: "S Suresh",
    designation: "FCA",
    image: "./administrators/suresh.jpeg",
  },
];

function MemberCard({ member }) {
  return (
    <div className={`admin-card ${member.featured ? "featured-card" : ""}`}>
      <div className="admin-image-wrapper">
        <img src={member.image} alt={member.name} className="admin-image" />

        <div className="image-overlay">
          <span>View Profile</span>
        </div>
      </div>

      <div className="admin-info">
        <h4>{member.name}</h4>

        {member.designation && (
          <p className="admin-designation">{member.designation}</p>
        )}
      </div>
    </div>
  );
}

export default function Administrators() {
  return (
    <section className="administrators-section">

      {/* Heading */}
      {/* <div className="admin-heading">
        <span className="heading-small">OUR LEADERSHIP</span>

        <h1>
          Trustees & <span>Committees</span>
        </h1>

        <div className="heading-line">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>

        <p>
          The dedicated members entrusted with the administration,
          guidance and continued development of the institution.
        </p>
      </div> */}

      {/* Trustee */}
      <div className="trustee-section">
        <div className="trustee-card">

          {/* <div className="trustee-image-container">
            <img
              src={trustee.image}
              alt={trustee.name}
              className="trustee-image"
            />
          </div> */}

          <div className="trustee-content">
            <span className="profile-label">Administration</span>

            {/* <h2>{trustee.name}</h2> */}

            <div className="gold-line"></div>

            {/* <p>
              His Highness serves as the Trustee, providing leadership,
              vision and guidance for the institution and its activities.
            </p> */}

            {/* <div className="trustee-designation">
              <span>✦</span>
              {trustee.designation}
            </div> */}
          </div>

        </div>
      </div>

      {/* Administrative Committee */}
      <section className="committee-section">

        <div className="committee-heading">
          <div>
            <span>01</span>
            <div>
              <small>LEADERSHIP</small>
              <h2>Administrative Committee</h2>
            </div>
          </div>

          {/* <p>
            Members responsible for the administration and management
            of the institution.
          </p> */}
        </div>

        {/* <div className="members-grid">
          {administrativeMembers.map((member, index) => (
            <MemberCard member={member} key={index} />
          ))}
        </div> */}

      </section>

      {/* Advisory Committee */}
      <section className="committee-section advisory-section">

        <div className="committee-heading">
          {/* <div>
            <span>02</span>
            <div>
              <small>LEADERSHIP</small>
              <h2>Advisory Committee</h2>
            </div>
          </div> */}

          {/* <p>
            Distinguished members providing valuable advice and
            guidance for the institution.
          </p> */}
        </div>

        {/* <div className="members-grid advisory-grid">
          {advisoryMembers.map((member, index) => (
            <MemberCard member={member} key={index} />
          ))}
        </div> */}

      </section>

    </section>
  );
}